<template>
  <!-- 添加一个场景页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

      <!-- <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang> -->
      <config-title-hang>
        <span slot="config_title_hang_ele2">循环定时任务</span>
      </config-title-hang>

      <config-hang
        :switchState=" serveOneLoopTask027Data.taskStatus "
        @click.native="showifBtnHandle"
      >
        <span slot="config_hang_ele2">循环定时状态</span>
        <img slot="config_hang_switchBtn_open" src="~assets/img/config/zhu_kai.png" alt />
        <img slot="config_hang_switchBtn_close" src="~assets/img/config/zhu_guan.png" alt />
      </config-hang>

      <config-hang inputID="xiugaiName2">
        <span slot="config_hang_ele2">打开时间段</span>
        <span slot="config_hang_ele_tishi">单位：分钟</span>
        <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />

        <input
          class="loop_task_input_with"
          type="text"
          slot="config_hang_input_right_min"
          id="xiugaiName2"
          placeholder="1-120分钟"
          v-model="serveOneLoopTask027Data.openTime"
          onkeyup="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
        />
      </config-hang>

      <config-hang inputID="xiugaiName5">
        <span slot="config_hang_ele2">关闭时间段</span>
        <span slot="config_hang_ele_tishi">单位：分钟</span>
        <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />

        <input
          class="loop_task_input_with"
          type="text"
          slot="config_hang_input_right_min"
          id="xiugaiName5"
          placeholder="1-120分钟"
          v-model="serveOneLoopTask027Data.closeTime"
          onkeyup="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
        />
      </config-hang>

      <config-hang @click.native="loopNumConfig022Btnhandle">
        <span slot="config_hang_ele2">循环次数设置</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        <!-- <span slot="config_hang_ele3">{{serveOneCycTask027Data.weeks}}</span> -->
        <span slot="config_hang_022_ele3">{{computerLoopConfigShow}}</span>
      </config-hang>


      <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">保存并返回</div>
    </div>
  </div>
</template>

<script>
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
import { configPageDataRequest } from 'views/afterLogin/config/deviceManagePage/deviceListPage/public_config_requery_js'
import {
  // deviceTypeJudge,
  // deviceTypeJudge1,
  publicDeviceTypeJudge
  // deviceStateFlip
} from 'components/content/contro-view/device-view/device-item-view-js'
export default {
  data() {
    return {
      ServeOneObjectinfo: {
        ////地址指向仓库
      },
      // serveOpenHour: '', ////打开的小时
      serveOpenMin: '', ///打开的分钟
      // serveCloseHour: '', ////关闭的小时
      serveCloseMin: '', ///关闭的分钟
      serveOneLoopTask027Data: {
        /////一个循环定时任务的数据
      }
    }
  },
  computed: {
    computerLoopConfigShow() {
      if (this.serveOneLoopTask027Data.loopNum === 0) {
        return '永久'
      }
      return this.serveOneLoopTask027Data.loopNum + '次'
    }
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    showifBtnHandle() {
      // 定时任务状态按钮按下了
      if (this.serveOneLoopTask027Data.taskStatus === 1) {
        this.serveOneLoopTask027Data.taskStatus = 0
      } else {
        this.serveOneLoopTask027Data.taskStatus = 1
      }
    },
    saveReturnBtnHandle() {
      if (!this.input027Judge()) return
      ////保存并返回按钮按下了
      ///设置插座循环定时 接口，获取数据
      console.log(this.serveOneLoopTask027Data)
      this.$request({
        method: 'post',
        url: '/device/updateLoopTimeById',
        data: {
          token: this.$store.state.token,
          deviceId: this.ServeOneObjectinfo.deviceId,
          taskStatus: this.serveOneLoopTask027Data.taskStatus,
          loopNum: this.serveOneLoopTask027Data.loopNum,
          openTime: this.serveOneLoopTask027Data.openTime,
          closeTime: this.serveOneLoopTask027Data.closeTime
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            // this.serveDeviceDetailsData = res.data.data ////拿到服务器返回的数据结果

            this.$showTipsToast(1, '修改成功', true) ////提示框
            this.$router.go(-1)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    input027Judge() {
      if (this.serveOneLoopTask027Data.taskStatus === '') {
        this.$toast('开关状态不能为空！')
        return false
      } else if (
        this.serveOneLoopTask027Data.openTime === '' ||
        this.serveOneLoopTask027Data.closeTime === ''
      ) {
        this.$toast('请设置打开和关闭时间段！')
      } else if (this.serveOneLoopTask027Data.loopNum === '') {
        this.$toast('循环次数不能为空！')
        return false
      }
      return true
    },
    loopNumConfig022Btnhandle() {
      this.$router.push('selectLoopNum')
      // this.$router.push({
      //   path: 'selectLoopNum',
      //   query: { serveOneLoopTask027Data: this.serveOneLoopTask027Data }
      // })
    }
  },
  watch: {
    // ////实时监测用户输入的时间是否合法
    'serveOneLoopTask027Data.openTime': function(val) {
      console.log(val + typeof val)
      if (val === '') {
        this.serveOneLoopTask027Data.openTime = '' ////用户可以不填时间
        return
      }
      if (Number(val) < 1) {
        this.serveOneLoopTask027Data.openTime = 1
      } else if (Number(val) > 120) {
        this.serveOneLoopTask027Data.openTime = 120
      } else {
        this.serveOneLoopTask027Data.openTime = Number(val)
      }

      console.log(this.serveOneLoopTask027Data.openTime)
    },

    // ////实时监测用户输入的时间是否合法
    'serveOneLoopTask027Data.closeTime': function(val) {
      console.log(val + typeof val)
      if (val === '') {
        this.serveOneLoopTask027Data.closeTime = '' ////用户可以不填时间
        return
      }
      if (Number(val) < 1) {
        this.serveOneLoopTask027Data.closeTime = 1
      } else if (Number(val) > 120) {
        this.serveOneLoopTask027Data.closeTime = 120
      } else {
        this.serveOneLoopTask027Data.closeTime = Number(val)
      }

      console.log(this.serveOneLoopTask027Data.closeTime)
    }
  },
  mounted() {
    console.log('mounted阶段')
  },
  created() {
    console.log('created阶段')
    this.serveOneLoopTask027Data = this.$store.state.configinfo.serveOneLoopTask027Data ////循环定时信息拿过来
    console.log(this.serveOneLoopTask027Data)

    this.ServeOneObjectinfo = this.$store.state.configinfo.ServeOneObjectinfo ////一个对象的地址信息拿过来
    console.log(this.ServeOneObjectinfo)
    // console.log(this.ServeOneObjectinfo)
    ///定时设备对象需要处理一下定时时间 打开的时间
    // if (this.serveOneCycTask027Data.openTime != '') {
    //   ///处理拿到的时间
    //   this.serveOpenHour = this.serveOneCycTask027Data.openTime.match(
    //     /(\S*):/
    //   )[1] ////拿到时间之后  取出：之前的小时 取字符串
    //   this.serveOpenMin = this.serveOneCycTask027Data.openTime.match(
    //     /:(\S*)/
    //   )[1] ////拿到时间之后  取出：之后的分钟 取字符串
    // }
    ///定时设备对象需要处理一下定时时间 关闭的时间
    // if (this.serveOneCycTask027Data.closeTime != '') {
    //   ///处理拿到的时间
    //   this.serveCloseHour = this.serveOneCycTask027Data.closeTime.match(
    //     /(\S*):/
    //   )[1] ////拿到时间之后  取出：之前的小时 取字符串
    //   this.serveCloseMin = this.serveOneCycTask027Data.closeTime.match(
    //     /:(\S*)/
    //   )[1] ////拿到时间之后  取出：之后的分钟 取字符串
    // }

    // console.log(this.serveOneCycTask027Data);
  }
}

/**
 * 
 *    此页面进入之前1，得到 asyUpdataServeOneObjectinfo这个数据提交到仓库  2，传参跳页面  如下举例
 *       // 获取设备详情 接口，获取数据
      this.$request({
        method: "post",
        url: "/device/findDeviceById",
        data: {
          token: this.$store.state.token,
          deviceId: deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了 数据地址存到仓库
            this.$store.dispatch("asyUpdataServeOneObjectinfo", res.data.data); ///异步提交对象信息地址到仓库

            // 进入下一个页面
            this.$router.push({
              path: "deviceObjectDetails",
              query: {
                title: title,  
                deviceId: deviceId,
                productCode: productCode
              }
            });
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
 */
</script>

<style>
div .loop_task_input_with {
  width: 120px;
}
</style>